import { render, staticRenderFns } from "./clickToCallTable.vue?vue&type=template&id=02367fa0"
import script from "./clickToCallTable.vue?vue&type=script&lang=ts"
export * from "./clickToCallTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports